import React from 'react';
import { Check, Clock } from 'lucide-react';

const FeaturesList = ({ 
  features = [], 
  duration = null,
  className = '' 
}) => {
  // Combine duration with features
  const allFeatures = [
    ...(duration ? [{ text: `${duration} hours`, isDuration: true }] : []),
    ...features.map(feature => ({ text: feature, isDuration: false }))
  ];

  if (allFeatures.length === 0) {
    return null;
  }

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${className}`} style={{ columnGap: '3rem', rowGap: '0.75rem' }}>
      {allFeatures.map((item, idx) => (
        <div key={idx} className="flex items-center text-sm text-gray-700">
          {item.isDuration ? (
            <Clock className="w-4 h-4 text-black mr-2 flex-shrink-0" />
          ) : (
            <div className="w-4 h-4 border border-black rounded-full flex items-center justify-center mr-2 flex-shrink-0">
              <Check className="w-2.5 h-2.5 text-black stroke-[3]" />
            </div>
          )}
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default FeaturesList;

